import { render, staticRenderFns } from "./CopyId.vue?vue&type=template&id=f1d0751c&scoped=true&lang=pug&"
import script from "./CopyId.vue?vue&type=script&lang=ts&"
export * from "./CopyId.vue?vue&type=script&lang=ts&"
import style0 from "./CopyId.vue?vue&type=style&index=0&id=f1d0751c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d0751c",
  null
  
)

export default component.exports